jQuery(document).ready(function($) {
    const modal = new bootstrap.Modal("#faqModal", {
        keyboard: false
    })
    $('.faq-item').on('click', function(e) {
        e.preventDefault()
        let title = $(this).attr("data-title")
        let key = $(this).attr("data-key")
        let area = $(this).attr("data-area")
        let id = $(this).attr("data-id")
       // console.log(my_ajax_object.ajax_url)
        $.ajax({
            url: my_ajax_object.ajax_url, // Defined in PHP (see below)
            type: 'POST',
            data: {
                action: 'faq_popup',
                key,
                area,
                id
            },
            success: function(response) {
                document.getElementById('faqModalText').innerHTML = response.data.text
                document.getElementById('faqModalTitle').innerHTML = title

                modal.show()
            },
            error: function(errorThrown){

                console.log(errorThrown)
            }
        })
    })
})